import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { RichsnipetService } from 'dmmp-services'

@Component({
  selector: 'dmmp-website-related-programs',
  templateUrl: './website-related-programs.component.html',
})
export class WebsiteRelatedProgramsComponent implements OnInit {
  @Input() data
  @Input() identifier
  @Input() category
  @Input() urlPayment
  @Input() privateKey
  @Output() page = new EventEmitter()
  schema
  constructor(private richsnipetService: RichsnipetService) {}

  ngOnInit() {
    this.schema = this.richsnipetService.setupJsonCourse(this.data.content)
  }
}
